package waldo.sankan.lineamunicipalkmp.web.screens

import androidx.compose.runtime.*
import androidx.compose.runtime.getValue
import androidx.compose.runtime.setValue
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.disabled
import org.jetbrains.compose.web.attributes.readOnly
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.css.keywords.auto
import org.jetbrains.compose.web.dom.*
import waldo.sankan.lineamunicipalkmp.web.components.FilterDropdown
import kotlin.js.Date


@Composable
fun BotonesBasicos(
    uiState: AdminPanelUiState,
    onBack: () -> Unit,
    viewModel: AdminPanelViewModel
) {
    // Variables de estado locales para manejar los inputs de fecha
    var fechaInicioStr by remember { mutableStateOf("") }
    var fechaFinStr by remember { mutableStateOf("") }

    Div({
        style {
            display(DisplayStyle.Flex);
            flexDirection(FlexDirection.Row);
            gap(16.px); // Reducimos un poco el gap para que quepa todo
            padding(16.px);
            backgroundColor(Color("#e9ecef"));
            borderRadius(8.px);
            marginBottom(32.px);
            alignItems(AlignItems.Center);
        }
    }) {
//////////////////////////////////////////////////////////////////////////////////////////
        Div({ style { flex(1) } }) // Spacer
//////////////////////////////////////////////////////////////////////////////////////////
        // --- BOTÓN DE VOLVER, EMPUJADO A LA DERECHA ---

        Button(attrs = {
            onClick { onBack() }
            style {
                padding(14.px);
                fontSize(16.px);
                fontWeight("bold");
                color(Color.white);
                backgroundColor(Color("#FB8C00"));
                borderRadius(8.px);
                cursor("pointer") }
        }) { Text("Volver al Panel") }
    }
}




@Composable
fun IngresoIncidenciaScreen(
    viewModel: AdminPanelViewModel,
    onBack: () -> Unit
) {
    val uiState by viewModel.uiState.collectAsState()

    // --- Variables de estado del formulario (DINÁMICAS) ---
    var nombreCiudadano by remember { mutableStateOf("") }
    var rutCiudadano by remember { mutableStateOf("") }
    var direccionTexto by remember { mutableStateOf("") }
    var descripcion by remember { mutableStateOf("") }
    var errorFormulario by remember { mutableStateOf<String?>(null) }

    // --- ESTADO PARA LOS DROPDOWNS ---
    var tipoIncidenciaSeleccionado by remember { mutableStateOf<String?>(null) }
    val rolAdmin = uiState.rolAdmin?.rol ?: "COMUNAL"
    var comunaSeleccionada by remember(uiState.rolAdmin) { 
        mutableStateOf(if (rolAdmin != "GENERAL") uiState.rolAdmin?.comunaAsignadaDisplayName else null) 
    }

    // --- ESTADO PARA LAS COORDENADAS ---
    var latitudConfirmada by remember { mutableStateOf<Double?>(null) }
    var longitudConfirmada by remember { mutableStateOf<Double?>(null) }

    // Obtenemos las listas para los dropdowns desde el ViewModel
    val tiposDisponibles = remember(uiState.tiposIncidencia) {
        uiState.tiposIncidencia.map { it.nombreDisplay ?: it.nombre }.distinct().sorted()
    }
    val comunasDisponibles = remember(uiState.comunas) {
        uiState.comunas.map { it.comunaDisplayName }.distinct().sorted()
    }

    LaunchedEffect(Unit) {
        val callback = { lat: Double, lng: Double, placeName: String ->
            latitudConfirmada = lat
            longitudConfirmada = lng
            direccionTexto = placeName
        }
        js("initMapForEntry")(callback)
    }


        // --- VISTA PRINCIPAL DEL PANEL (TABLA E INCIDENCIAS) ---
        Div({
            style {
                display(DisplayStyle.Flex);
                width(100.percent);
                backgroundColor(Color("#1976D2"));
                property("border-bottom",
                    "2px solid #1565C0")
            }
        }) {
            // Logo y Título
            Div({
                style {
                    width(15.percent);
                    display(DisplayStyle.Flex);
                    justifyContent(JustifyContent.Center)
                    alignItems(AlignItems.Center);
                    paddingRight(16.px);
                    paddingLeft(16.px);
                    boxSizing("border-box")
                }
            }) {
                Div({
                    style {
                        display(DisplayStyle.Flex);
                        flexDirection(FlexDirection.Column);
                        alignItems(AlignItems.Center);
                        gap(8.px) } }) {
                    Img(src = "logo_icon.svg",
                        attrs = {
                            style { height(120.px) } })
                    H2({
                        style { fontSize(24.px);
                            color(Color.white);
                            margin(0.px);
                            property("text-shadow",
                                "1px 1px 2px rgba(0,0,0,0.4)") } }) {
                        Span({
                            style {
                                fontWeight("normal") } })
                        { Text("Linea") }
                        Span({
                            style {
                                fontWeight("bold") } })
                        { Text("Muni") }
                    }
                    P(attrs = { attr("translate", "no");
                        style { fontSize(16.px);
                            color(Color("#FB8C00"));
                            fontWeight("bold");
                            letterSpacing(1.px);
                            margin(0.px) } })
                    { Text("SMART CITY") }
                }
            }

            // Panel de Control y Filtros
            Div({
                style {
                    width(85.percent);
                    padding(32.px);
                    display(DisplayStyle.Flex)
                    flexDirection(FlexDirection.Column);
                    gap(24.px);
                    boxSizing("border-box")
                }
            }) {
                Div({
                    style {
                        display(DisplayStyle.Flex);
                        justifyContent(JustifyContent.SpaceBetween);
                        alignItems(AlignItems.Center);
                    }
                }) {
                    H1({
                        style {
                            color(Color.white);
                            fontSize(32.px);
                            fontWeight(700);
                            paddingTop(30.px)
                            margin(0.px);
                            flex(1);
                            textAlign("center")
                        }
                    }) { Text("INGRESO DE INCIDENCIAS RECIBIDAS TELEFONICAMENTE") }
                }


                BotonesBasicos(uiState = uiState, onBack = onBack, viewModel = viewModel)
            }
        }

        Div({
            style {
                display(DisplayStyle.Flex);
                justifyContent(JustifyContent.SpaceBetween);
                alignItems(AlignItems.Center);
            }
        }) {
            H1({
                style {
                    backgroundColor(Color("#1976D2"));
                    color(Color.white);
                    fontSize(24.px);
                    fontWeight(700);
                    paddingLeft(32.px)
                    margin(0.px);
                    flex(1);
                    textAlign("left")
                }
            }) { Text("Complete los siguientes campos para registrar la incidencia.") }
        }

///////////////////////////////////////////////////////////////////////////////////////////////////////
    ///FIN ENCABEZADO ESTANDAR
    //////////////////////////////////////////////////////////////////////////////////////////////

    // --- CONTENEDOR MAESTRO DE DOS COLUMNAS ---
    Div({
        style {
            display(DisplayStyle.Flex)
            gap(32.px)
            padding(32.px)
            maxWidth(1800.px)
            margin(0.px, 0.px)
        }
    }) {

            // --- COLUMNA 1: FORMULARIO (50%) ---
            Div({
                style {
                    flex(1) // Ocupa el 50% del espacio
                    display(DisplayStyle.Flex)
                    flexDirection(FlexDirection.Column)
                    gap(20.px)
  //                  backgroundColor(Color.white)
                    backgroundColor(Color("#f2f2f2"))
                    padding(24.px)
                    borderRadius(8.px)
                    property("box-shadow", "0px 4px 15px rgba(0,0,0,0.08)")
                }
            }) {
                // ... (AQUÍ VA TODO TU CÓDIGO DEL FORMULARIO, DESDE "Fila 1" hasta el botón "Guardar")

// --- Fila 1: Datos del Ciudadano ---
                Div({
                    style {
                        display(DisplayStyle.Flex);
                        paddingTop(20.px)
                        gap(16.px);
                        alignItems(AlignItems.End) } }) {
                    Div({
                        style { flex(1) } }) {
                        Label(forId = "nombreCiudadano")
                        { Text("Nombre del Ciudadano") }
                        Input(type = InputType.Text) {
                            id("nombreCiudadano")
                            value(nombreCiudadano)
                            onInput { nombreCiudadano = it.value }
                            style {
                                width(100.percent);
                                padding(10.px);
                                boxSizing("border-box");
                                borderRadius(4.px);
                                border(1.px, LineStyle.Solid, Color("#cccccc")) }
                        }
                    }
                    Div({
                        style { flex(1) } }) {
                        Label(forId = "rutCiudadano")
                        { Text("RUT del Ciudadano") } // Ya no es opcional
                        Input(type = InputType.Text) {
                            id("rutCiudadano")
                            value(rutCiudadano)
                            onInput { rutCiudadano = it.value }
                            style {
                                width(100.percent);
                                padding(10.px);
                                boxSizing("border-box");
                                borderRadius(4.px);
                                border(1.px, LineStyle.Solid, Color("#cccccc")) }
                        }
                    }
                }


                // --- FILA 2: ¡DROPDOWNS DINÁMICOS! ---
                Div({
                    style {
                    display(DisplayStyle.Flex);
                    gap(16.px);
                    alignItems(AlignItems.End) } }) {
                    // Dropdown Tipo de Incidencia
                    FilterDropdown(
                        "Tipo de Incidencia:",
                        tipoIncidenciaSeleccionado,
                        tiposDisponibles,
                        onValueChanged = { tipoIncidenciaSeleccionado = it }
                    )
                    // Dropdown Comuna (🛡️ Blindado por Soberanía)
                    if (rolAdmin == "GENERAL") {
                        FilterDropdown(
                            "Comuna:",
                            comunaSeleccionada,
                            comunasDisponibles,
                            onValueChanged = { comunaSeleccionada = it }
                        )
                    } else {
                        // Mostramos la comuna bloqueada visualmente
                        Div({ style { display(DisplayStyle.Flex); alignItems(AlignItems.Center); gap(8.px); backgroundColor(Color("#e9ecef")); padding(8.px); borderRadius(6.px) } }) {
                            B { Text("📍 Comuna:") }
                            Span { Text(comunaSeleccionada ?: "No asignada") }
                        }
                    }
                }

// --- Fila 3: Dirección ---
                Div {
                    Label(forId = "direccion") { Text("Dirección (comience a escribir y seleccione)") }
                    Input(type = InputType.Text) {
                        id("direccion") // Este ID es VITAL para que JS lo encuentre
                        value(direccionTexto)
                        onInput {
                            direccionTexto = it.value
                            // Si el usuario borra la dirección, reseteamos las coordenadas
                            if(it.value.isBlank()){
                                latitudConfirmada = null
                                longitudConfirmada = null
                            }
                        }
                        style {
                            width(100.percent);
                            padding(10.px);
                            boxSizing("border-box");
                            borderRadius(4.px);
                            border(1.px, LineStyle.Solid, Color("#cccccc")) }
                    }
                }

// --- Fila 4: Descripción ---
                Div {
                    Label(forId = "descripcion")
                    { Text("Descripción de la Incidencia") }
                    TextArea {
                        id("descripcion")
                        value(descripcion)
                        onInput { descripcion = it.value }
                        style {
                            width(100.percent);
                            height(120.px);
                            padding(10.px);
                            boxSizing("border-box");
                            borderRadius(4.px);
                            border(1.px, LineStyle.Solid, Color("#cccccc")); fontFamily("sans-serif"); fontSize(16.px) }
                    }
                }

// --- Mensaje de Error y Botón de Acción ---
                if (errorFormulario != null) {
                    P({
                        style {
                            color(Color.red);
                            fontWeight("bold") } })
                    { Text(errorFormulario!!) }
                }
// --- SECCIÓN DE EVIDENCIA (CAPTURA DE CÁMARA/DRON) ---
                Div({ style { marginBottom(16.px); padding(12.px); backgroundColor(Color("#e3f2fd")); borderRadius(8.px) } }) {
                    B { Text("3. Adjuntar Evidencia Visual:") }
                    Div({ style { display(DisplayStyle.Flex); alignItems(AlignItems.Center); gap(12.px); marginTop(8.px) } }) {

                        // Input de archivo oculto
                        Input(type = InputType.File, attrs = {
                            id("file-upload-manual")
                            style { display(DisplayStyle.None) }
                            onChange { event ->
                                val file = event.target.files?.item(0)
                                viewModel.onImagenManualSeleccionada(file)
                            }
                        })

                        // Botón que dispara el click del input
                        Button(attrs = {
                            onClick { js("document.getElementById('file-upload-manual').click()") }
                            style {
                                padding(8.px, 16.px); backgroundColor(Color("#1976D2")); color(Color.white)
                                borderRadius(6.px); cursor("pointer"); border(0.px)
                            }
                        }) { Text(if (uiState.imagenSeleccionada != null) "📷 Cambiar Captura" else "📷 Adjuntar Captura") }

                        if (uiState.imagenSeleccionada != null) {
                            Span({ style { color(Color("#2E7D32")); fontWeight("bold"); fontSize(14.px) } }) {
                                Text("✅ Captura lista para enviar")
                            }
                        }
                    }
                }
                Div({
                    style {
                        display(DisplayStyle.Flex);
                        justifyContent(JustifyContent.FlexEnd);
                        gap(16.px) } }) {

                        Button(attrs = {
                            onClick {
                                if (nombreCiudadano.isBlank() || rutCiudadano.isBlank() || direccionTexto.isBlank() || descripcion.isBlank() || tipoIncidenciaSeleccionado == null || comunaSeleccionada == null) {
                                    errorFormulario = "Todos los campos son obligatorios."
                                } else if (latitudConfirmada == null || longitudConfirmada == null) {
                                    errorFormulario = "Por favor, seleccione una dirección válida del mapa para confirmar la ubicación."
                                } else {
                                    errorFormulario = null

                                    val tipoSeleccionado = uiState.tiposIncidencia.find { (it.nombreDisplay ?: it.nombre) == tipoIncidenciaSeleccionado }
                                    // FORZAMOS LA REGLA: Si el ID es el maestro, el nombre es "Basura"
                                    val nombreFinal = if (tipoSeleccionado?.id == "Xx9dXIOJmX6NQgc2a2kj") "Basura" else (tipoSeleccionado?.nombreDisplay ?: "General")

                                    // --- ¡LA CORRECCIÓN QUIRÚRGICA! ---
                                    val comunaSeleccionadaData = uiState.comunas.find { it.comunaDisplayName == comunaSeleccionada }

                                    if (tipoSeleccionado == null || comunaSeleccionadaData == null) {
                                        errorFormulario = "Error interno: No se pudo encontrar la referencia para el tipo o comuna seleccionada."
                                    } else {
                                        viewModel.onIngresarIncidenciaManual(
                                            NuevaIncidenciaManual(
                                                nombreCiudadano = nombreCiudadano,
                                                rutCiudadano = rutCiudadano,
                                                direccion = direccionTexto,
                                                descripcion = descripcion,
                                                lat = latitudConfirmada,
                                                lng = longitudConfirmada,
                                                tipoIncidenciaDisplayName = nombreFinal,
                                                tipoIncidenciaRef = tipoSeleccionado.id,
                                                comunaDisplayName = comunaSeleccionadaData.comunaDisplayName,
                                                comunaRef = comunaSeleccionadaData.id,
                                                regionDisplayName = comunaSeleccionadaData.regionDisplayName,
                                                regionRef = comunaSeleccionadaData.regionRef,
                                                idUsuarioSolucionadorAsignado = null,
                                                observacionSolucionador = null,
                                                usuarioAuthUid = "INGRESO_MANUAL_ADMIN"
                                            )
                                        )
                                    }
                                }
                            }

                            style {
                            padding(14.px);
                            fontSize(16.px);
                            fontWeight("bold");
                            color(Color.white);
                            backgroundColor(Color("#FB8C00"));
                            borderRadius(8.px);
                            cursor("pointer")
                        }
                        // ¡REGLA DE ENFRENTAMIENTO APLICADA! El botón se deshabilita si no hay coordenadas.
                        if (uiState.isLoadingGlobal || latitudConfirmada == null) {
                            disabled()
                        }
                    }) {
                        if (uiState.isLoadingGlobal) {
                            Text("Guardando...")
                        } else if (latitudConfirmada == null){
                            Text("Confirme Ubicación")
                        } else {
                            Text("Guardar Incidencia")
                        }
                    }
                }
            }

            // --- COLUMNA 2: MAPA (50%) ---
            Div({
                id("map-entry-canvas") // ¡ID CRUCIAL!
                style {
                    flex(1) // Ocupa el otro 50% del espacio
                    backgroundColor(Color.white)
                    padding(24.px)
                    borderRadius(8.px)
                    property("box-shadow", "0px 4px 15px rgba(0,0,0,0.08)")
                    display(DisplayStyle.Flex)
                    alignItems(AlignItems.Center)
                    justifyContent(JustifyContent.Center)
                    minHeight(400.px) // Altura mínima para que se vea bien
                    border(2.px, LineStyle.Dashed, Color("#cccccc"))
                }
            }) {
                P({
                    style {
                        color(Color.gray);
                        fontSize(20.px) } })
                { Text("Área reservada para el Mapa (Fase 2)") }
            }
        }
}




